import { provideContent, withMarkdownRenderer } from '@analogjs/content'
import { withShikiHighlighter } from '@analogjs/content/shiki-highlighter'
import { provideFileRouter, requestContextInterceptor } from '@analogjs/router'
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http'
import { ApplicationConfig, isDevMode, provideZoneChangeDetection } from '@angular/core'
import { provideClientHydration } from '@angular/platform-browser'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async'
import { withInMemoryScrolling } from '@angular/router'
import { provideTransloco } from '@jsverse/transloco'
import { TranslocoHttpLoader } from './transloco-loader'

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideFileRouter(withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
        provideHttpClient(withFetch(), withInterceptors([requestContextInterceptor])),
        provideClientHydration(),
        provideContent(withMarkdownRenderer(), withShikiHighlighter()),
        provideAnimationsAsync(),
        provideTransloco({
            config: {
                availableLangs: ['en', 'pl'],
                defaultLang: 'en',
                // Remove this option if your application doesn't support changing language in runtime.
                reRenderOnLangChange: true,
                missingHandler: {
                    allowEmpty: true
                },
                prodMode: !isDevMode()
            },
            loader: TranslocoHttpLoader
        })
    ]
}
